export const testimonials = [
  {
    content:`All services is in one application .easy to use and quick response. thanks to management's`,
    name: 'Dushyant',
    date: 'Feb 16, 2024',
  },
  {
    content:`This is very usefull application. Today i tried and there is very good custmer service .1st time i came to know so everybody should use this application for better experience. Thank you all team this is very helpfull application ever you lunched.🙏`,
    name: 'Arun',
    date: 'Mar 4, 2024',
  },
  {
    content:`This app is amazing and it is the great initiative by the government Its interface is user friendly and it provides digilocker app facilities in it which makes it more efficient.`,
    name: 'Saurabh',
    date: 'Apr 29, 2024',
  },
  {
    content:`It is the Official App of the Government of India which contains all the Facilities provided by Government such as Digilocker, Ration Distribution Agencies of State, Different Government Benefits and Facilities for the Citizens. Very nice app and helpful for the Citizens.`,
    name: 'Roshin',
    date: 'May 6, 2024',
  },
  {
    content:`This app is excellent to connect with government officials, I was overwhelmed when I got the pf amount settled through this app intact within three days. Thanks to the officials whoever helped me in this. Regards`,
    name: 'Gayathri',
    date: 'May 24, 2024',
  },
  {
    content:`Way too cool. It works with like 98% accuracy. I have checked it for Marathi, Hindi, Gujrati to English and Vice Versa.. Great Work...`,
    name: 'Amit',
    date: 'May 26, 2024',
  },
  {
    content:`Umang application is a fast superb and nice experience please use this application and all government services available this application`,
    name: 'Anil',
    date: 'June 3, 2024',
  }

];
